import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { appVersionAtom, isAppPreReleaseVersionAtom } from "~/state/atoms";
import { getAppVersion } from "~/utils/flutter";

const SetAppVersion = () => {
  const [appVersion, setAppVersion] = useRecoilState(appVersionAtom);
  const [isAppPreReleaseVersion, setIsAppPreReleaseVersion] = useRecoilState(
    isAppPreReleaseVersionAtom,
  );

  useEffect(() => {
    getAppVersion();
  }, []);

  useEffect(() => {
    if (
      appVersion === "" ||
      appVersion.startsWith("1.0") ||
      appVersion.startsWith("1.1") ||
      appVersion.startsWith("1.2") ||
      appVersion.startsWith("1.3")
    ) {
      setIsAppPreReleaseVersion(false);
      return;
    }
    setIsAppPreReleaseVersion(true);
  }, [appVersion]);

  return (
    <section>
      <div
        id="GET_APP_VERSION_DIV"
        onClick={(e) => {
          setAppVersion(e.currentTarget.title);
        }}
      />
    </section>
  );
};

export default SetAppVersion;
